import classNames from 'classnames/bind';
import { ColumnTag } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Enums from 'utils/EnumsManager';
import { moveToZone, swapCards } from '../../flow/actions';
import styles from '../../index.less';
import { addActions } from 'components/hoc/index';

const cx = classNames.bind(styles);
const { DROPZONES, FieldTypes, FieldTypesInArray } = Enums;
const { SIDER, AGGREGATES } = DROPZONES;

const defaultProps = {
  closable: true,
  restriction: false,
  fieldDeleted: false,
};
const propTypes = {
  closable: PropTypes.bool,
  restriction: PropTypes.bool,
  fieldDeleted: PropTypes.bool,
};

class CommonDraggableTag extends Component {
  handleDeleteClick = id => this.props.moveToZone(SIDER, id);

  render() {
    const {
      id,
      label,
      actionIcon,
      closable,
      connectDragSource,
      connectDropTarget,
      isDragging,
      restriction,
      fieldDeleted,
      groupStyle
    } = this.props;

    return connectDragSource(
      connectDropTarget(
        <div
          className={cx('tagWrapper')}
          style={{ opacity: isDragging ? 0 : 1 }}
        >
          <ColumnTag
            onClose={() => this.handleDeleteClick(id)}
            closable={closable}
            restriction={restriction}
            fieldDeleted={fieldDeleted}
          >
            <div className={`${groupStyle} ${cx('tagContent')} truncate`}>
              {label}
              {actionIcon}
            </div>
          </ColumnTag>
        </div>
      )
    );
  }
}

const mapStateToProps = ({ global }) => ({
  lang: global.language
});
const mapDispatchToProps = {
  moveToZone,
  swapCards
};

/**
 * Drag configs
 */
const getDragType = props => props.type;
const dragSpec = {
  canDrag: props => !props.disabled || props.belongTo !== SIDER,
  beginDrag: props => ({ id: props.id, index: props.index, belongTo: props.belongTo })
};
const dragCollect = (connector, monitor) => ({
  connectDragSource: connector.dragSource(),
  isDragging: monitor.isDragging()
});
/**
 * Drop configs
 */
const getDropType = props => {
  if (props.belongTo === AGGREGATES) {
    return FieldTypes.NumberInput;
  }
  return FieldTypesInArray;
};
const dropSpec = {
  hover: (props, monitor, component) => {
    if (!component) return null;

    const dragItem = monitor.getItem();
    const dropItem = {
      id: props.id,
      index: props.index,
      belongTo: props.belongTo
    };

    // Don't replace items with themselves
    if (dragItem.id === dropItem.id) return;

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get horizontal middle
    const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;

    // Get pixels to the left
    const hoverClientX = monitor.getClientOffset().x - hoverBoundingRect.left;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%
    // Dragging left
    if (dragItem.index < dropItem.index && hoverClientX < hoverMiddleX) return;

    // Dragging to right
    if (dragItem.index > dropItem.index && hoverClientX > hoverMiddleX) return;

    // // Time to actually perform the action
    props.swapCards(dragItem.id, dropItem.id);

    // // Note: we're mutating the monitor item here!
    // // Generally it's better to avoid mutations,
    // // but it's good here for the sake of performance
    // // to avoid expensive index searches.
    // monitor.getItem().index = dropItem.index;
  }
};
const dropCollect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget()
});

const enhancers = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  addActions('actionIcon'),
  DragSource(getDragType, dragSpec, dragCollect),
  DropTarget(getDropType, dropSpec, dropCollect)
);

CommonDraggableTag.defaultProps = defaultProps;
CommonDraggableTag.propTypes = propTypes;
export default enhancers(CommonDraggableTag);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/CommonDraggableTag/index.jsx